
import en_AU from './en-AU.js';

export default {
	'en-AU': en_AU,
};
